export default __webpack_public_path__ + "sorting-icon-down.svg";